import styled from "styled-components";
import Check from "@material-ui/icons/Check";
import { FormControl, Select, MenuItem, Grid } from "@material-ui/core";

export const STChipWrap = styled.div`
  display: "flex";
  flex-wrap: "wrap";
`;

export const STFormControl = styled(FormControl).attrs({
  root: "root",
})`
  && {
    min-width: 120px;
    max-width: 300px;
    margin-top: 10px;
  }
`;

export const STSelect = styled(Select).attrs({
  classes: { selectMenu: "selectMenu" },
})`
  && {
    .selectMenu {
      white-space: inherit;
    }
  }
`;

export const STIconGrid = styled(Grid)`
  && {
    margin-top: auto;
    margin-bottom: auto;
    margin-right: 5px;
  }
`;

export const STMenuItem = styled(MenuItem)`
  && {
    height: 40px;
    padding-top: 11px;
    padding-bottom: 11px;
    box-sizing: content-box;
  }
`;
